import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
  inject,
  input,
  output
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AysVirtualClinic } from '@bindoc-projects/virtual-clinic-domain-lib';
import { IftaLabel } from 'primeng/iftalabel';
import { InputText } from 'primeng/inputtext';

@Component({
    selector: 'ays-virtual-clinic-form',
    template: `
    @if (!!virtualClinic()) {
      <form>
        <div>
          <p-iftalabel>
            <input
              pInputText
              id="vc-clinic-name"
              fluid
              variant="filled"
              name="name"
              [formControl]="nameCtrl"
            />
            <label for="vc-clinic-name">Name / Bezeichnung</label>
          </p-iftalabel>
        </div>
      </form>
    }
  `,
    imports: [
        ReactiveFormsModule,
        FormsModule,
        IftaLabel,
        InputText,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AysVirtualClinicFormClinicComponent implements OnInit {
  readonly virtualClinic = input<AysVirtualClinic>();

  public readonly virtualClinicChange = output<AysVirtualClinic>();

  public readonly nameCtrl: FormControl<string> = new FormControl<string>('');

  private readonly _destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    if (this.virtualClinic()) {
      this.nameCtrl.patchValue(this.virtualClinic().name);
    }

    this.nameCtrl.valueChanges
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((newName) => {
        this.virtualClinic().name = newName;
        this._onContainerChange();
      });
  }

  private _onContainerChange() {
    this.virtualClinicChange.emit(this.virtualClinic());
  }
}
